export const css = {
	root: '_36rXasqD',
	heading: '_2P4WApA8',
	' _key': 'afcpe-theme/afcpe/micro/base-widgets/accordion2'
};

export default css;
